import {API_EMOJI} from "./constants/CONST";
import {TFunction} from "i18next";
import {GameModes} from "./constants/EnumGameModes";
import {GameApi} from "./services/api/GameApi";

export function capitalize(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function flagUrl(code: string) {
    return `${API_EMOJI}${code}.svg`
}

/**
 * Get the difference in days between two dates
 * @param date1
 * @param date2
 * 
 * @returns the difference in minutes
 */
export function getDifferenceInMinutes(date1: Date, date2: Date = new Date()) {
    const diff = date2.getTime() - date1.getTime();
    return Math.round(diff / (1000 * 60));
}

export function getRelativeTime(t: TFunction<"translation", undefined>, date: Date) {
    const differenceInMinutes = getDifferenceInMinutes(date)

    let translateString;
    if (differenceInMinutes > 1440) { // more than 24 hours
        translateString = t("global.x-days-ago", {count: Math.round(differenceInMinutes / 1440)});
    } else if (differenceInMinutes > 60) { // more than 60 minutes
        translateString = t("global.x-hours-ago", {count: Math.round(differenceInMinutes / 60)});
    } else if (differenceInMinutes > 0) { // more than few seconds
        translateString = t("global.x-minutes-ago", {count: differenceInMinutes});
    } else {
        translateString = t("global.few-secondes-ago");
    }

    return translateString;
}


export async function getGameModeNameFromGameModeId(gameModeId: number): Promise<GameModes> {
    let gamemodes;
    try {
        gamemodes = await GameApi.getAllGameModes();
    } catch (e) {
        return GameModes.UNDEFINED;
    }

    const difficulty = gamemodes.find(gm => gm.id === gameModeId);

    if (difficulty === undefined) {
        return GameModes.UNDEFINED;
    }

    const gameMode = gamemodes
        .find(gm => gm.id === difficulty.idGameTheme
    );

    if (gameMode === undefined || gameMode.name === undefined) {
        return GameModes.UNDEFINED;
    }

    const gameModeName = gameMode.name!.toLowerCase()
    switch (gameModeName) {
        case "classic solo":
            return GameModes.CLASSIC_SOLO;
        case "race solo":
            return GameModes.RACE_SOLO;
        case "fastaily":
            return GameModes.FASTAILY;
        default:
            return GameModes.UNDEFINED;
    }
}
